
export function travelTime (distance, speed) {
  let travelTime = distance / speed
  return travelTime
}
